import * as yup from 'yup';
import { isNotFutureDateValidator } from '@helpers/utils';

export const completePaymentSchema = yup.object().shape({
  bank_details: yup.array().of(
    yup.object().shape({
      supplier_bank_id: yup.string().required('Supplier Bank ID is required'),
      supplier_bank_account_number: yup
        .string()
        .required('Supplier Bank Account Number is required'),
      supplier_name: yup.string().required('Supplier Name is required'),
      payment_date: yup
        .date()
        .required('Payment Date is required')
        .test(isNotFutureDateValidator()),
      remarks: yup.string().nullable().notRequired(),
      reference_number: yup.string().required('Reference Number is required'),
      payment_info_ids: yup.array().of(yup.string()).required('Payment Info IDs is required')
    })
  )
});

export const AddTDSTCSSchema = yup.object().shape({
  tds: yup
    .number()
    .required('TDS is required')
    .min(0, 'TDS should be greater than or equal to 0')
    .typeError('TDS should be a number'),
  tcs: yup
    .number()
    .required('TCS is required')
    .min(0, 'TCS should be greater than or equal to 0')
    .typeError('TCS should be a number')
});
